import { useContext, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { BodyWrapper, Header, Loader, MainWrapper } from '@components';
import { GlobalContext } from '@contexts';
import { ChevronRightIcon } from '@svgs';
import { groupsQuery, userMutation } from '@queries';

import AccountSidebar from '../components/AccountSidebar/AccountSidebar.jsx';
import UserForm from '../components/UserForm/UserForm.jsx';

export const AddUser = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // save user
  const mutation = useMutation(
    userMutation(null, {
      onSuccess: (data) => {
        // invalidate list views so they are re-fetched
        queryClient.invalidateQueries({ queryKey: ['users', 'list'] });
        // navigate to the edit view
        navigate(`/dashboard/users/${data.id}`);
      },
    }),
  );

  // get groups
  const { data: groupsData, isPending: groupsIsPending } =
    useQuery(groupsQuery());

  return (
    <>
      <Header />
      <BodyWrapper>
        <AccountSidebar />
        <MainWrapper>
          <div className="sb-main-breadcrumbs">
            <ul className="sb-flex">
              <li className="sb-flex">
                <span>Account settings</span>
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">
                <Link to={`/dashboard/users`}>Users</Link>
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">
                <span>Add</span>
              </li>
            </ul>
          </div>
          <div className="sb-manage-content">
            <h1>Add</h1>
            {groupsIsPending && (
              <Loader className="sb-loader sb-loader-large" />
            )}
            {groupsData && (
              <UserForm mutation={mutation} groupsData={groupsData} />
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
